import { render } from "./ModalPopup.vue?vue&type=template&id=64729656&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"

import "./ModalPopup.vue?vue&type=style&index=0&id=64729656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64729656"]])

export default __exports__